import { Page, Layout } from "@shopify/polaris";

import UpsellSetting from "../componens/upsellSetting";

export default function Upsell() {
  return (
    <Page>
      <Layout>
        <Layout.Section>
          <UpsellSetting />
        </Layout.Section>
      </Layout>
    </Page>
  );
}
